import { useAppSelector } from 'app/hooks';
import { ReactNode } from 'react';

type CanAccessProps = {
  permission?: string;
  role?: string;
  children: ReactNode;
};

export default function CanAccess({
  permission,
  role,
  children
}: CanAccessProps) {
  const { user } = useAppSelector((state) => state.auth);

  if (
    (!permission || !user?.permissions.includes(permission)) &&
    (!role || !user?.roles.includes(role))
  ) {
    return null;
  }

  return children;
}
